module.exports = __webpack_public_path__ + "img/utilizator_premium_fail.6651b08b.png";